module.exports = __webpack_public_path__ + "img/logoseebcaratinga.fe2d5741.svg";